<template>
  <div id="app">
    <loading v-if="loading"></loading>
    <div class="website-wrraper" v-else>
      <!-- mobile menu -->
      <MobileMenu></MobileMenu>
      <!-- end mobile menu-->
      <!-- top header -->
      <top-header></top-header>
      <!-- header component -->
      <Header></Header>
      <!-- router view -->
      <!-- loading -->
      <vue-page-transition name="fade-in-left">
        <router-view></router-view>
      </vue-page-transition>

      <!-- footer links -->
      <!--      <links-footer v-if="checkPath"></links-footer>-->
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/layouts/TheHeader";
import Footer from "./components/layouts/TheFooter";
import MobileMenu from "@/components/layouts/TheMobileMenu";
import TopHeader from "@/components/layouts/TheTopHeader";
import Loading from "@/components/Loading/loading";

export default {
  name: 'LayoutDefault',
  components: {
    Loading,
    TopHeader,
    MobileMenu,
    Footer,
    Header
  },
  data() {
    return {
      loading: true,
    }
  },
  watch: {
    '$route'() {
      $("html, body").animate({ scrollTop: 0 }, 600);
    }
  },
  methods: {
    get_website_setting() {
      this.$API.web.setting.get_setting()
          .then(response => {
            this.$store.state.settings_website = response.data;

            this.$API.web.InternalSettings.get_InternalSetting()
                .then(response => {
                  this.$store.state.InternalSettings = response.data;
                  let root = document.documentElement;
                  root.style.setProperty('--mainColors', this.$store.state.InternalSettings[0].color);
                  // root.style.setProperty('--mainColors', "#0093D2");
                  this.loading = false;
                })
                .catch(() => {
                });
          })
          .catch(error => {
            this.loading = false;
          });
    },
  },
  computed: {
    checkPath() {
      if (this.$route.path == '/' || this.$route.path == '/competitions') {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {

    this.get_website_setting();

    this.$API.userProfile.getProfile()
        .then(response => {
          this.$store.commit('getUserData', response.data.data);
        })
        .catch(error => {
          if (error.response.data.message == 'Token is Invalid' || error.response.data.message == 'Token is Expired') {
            this.$store.commit('editUserState', false);
            this.$store.commit('getUserToken', null);
            this.$store.commit('getUserData', null);
            this.$store.commit('get_userTeam', null);
            localStorage.removeItem('token');
            if (this.$route.path == '/profile') this.$router.push('/');
          }
        });
  },

}
</script>

<style>
@import "./assets/css/global.css";


@media (max-width: 768px) {
  .headers {
    display: none;
  }

  .mobile-navbar {
    display: block;
  }
}
</style>
